function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import { MatcherType } from './core-video-config-types';
import { sdkLogger } from '../../logger';
import { CvsdkError, ErrorSeverity } from '../../error';
import { validate, satisfies } from '@sky-uk-ott/compare-versions';
function regexFromString(s) {
    var firstIndex = s.indexOf('/');
    var lastIndex = s.lastIndexOf('/');
    var isRegexString = firstIndex === 0 && lastIndex !== -1;
    if (!isRegexString) {
        return new RegExp(s);
    }
    var pattern = s.slice(1, lastIndex);
    var options = s.slice(lastIndex + 1);
    return new RegExp(pattern, options);
}
function createInvalidMatcherWarning(message) {
    return new CvsdkError('INVALID_MATCHER', message, ErrorSeverity.Warning);
}
function checkIsStringMatcher(matcherProperty) {
    return typeof matcherProperty === 'string' || (typeof matcherProperty === "undefined" ? "undefined" : _type_of(matcherProperty)) === 'object' && matcherProperty.type === MatcherType.String;
}
function testStringMatcher(matcher, deviceInfoString) {
    if (typeof matcher === 'string') {
        var regex = regexFromString(matcher);
        return regex.test(deviceInfoString);
    }
    var isBlacklistSpecified = matcher.isNot !== undefined && matcher.isNot.length > 0;
    var isWhitelistSpecified = matcher.is !== undefined && matcher.is.length > 0;
    if (!isBlacklistSpecified && !isWhitelistSpecified) {
        var errorMessage = 'A device matcher of type "String" was used without specifying any constraints';
        var error = createInvalidMatcherWarning(errorMessage);
        throw error;
    }
    if (isBlacklistSpecified) {
        var isBlacklisted = matcher.isNot.some(function(matcherString) {
            var regex = regexFromString(matcherString);
            return regex.test(deviceInfoString);
        });
        if (isBlacklisted) {
            return false;
        }
    }
    if (isWhitelistSpecified) {
        var isWhitelisted = matcher.is.some(function(matcherString) {
            var regex = regexFromString(matcherString);
            return regex.test(deviceInfoString);
        });
        if (!isWhitelisted) {
            return false;
        }
    }
    return true;
}
function checkIsNumberMatcher(matcherProperty) {
    return (typeof matcherProperty === "undefined" ? "undefined" : _type_of(matcherProperty)) === 'object' && matcherProperty.type === MatcherType.Number;
}
function testNumberMatcher(matcher, deviceInfoString) {
    var isMinSpecified = matcher.min !== undefined;
    var isMaxSpecified = matcher.max !== undefined;
    var isBlacklistSpecified = matcher.isNot !== undefined && matcher.isNot.length > 0;
    if (!isBlacklistSpecified && !isMinSpecified && !isMaxSpecified) {
        var errorMessage = 'A device matcher of type "Number" was used without specifying any constraints';
        var error = createInvalidMatcherWarning(errorMessage);
        throw error;
    }
    var deviceInfoNumber = parseInt(deviceInfoString, 10);
    if (isNaN(deviceInfoNumber)) {
        return false;
    }
    if (isBlacklistSpecified) {
        if (matcher.isNot.includes(deviceInfoNumber)) {
            return false;
        }
    }
    if (isMinSpecified) {
        if (deviceInfoNumber < matcher.min) {
            return false;
        }
    }
    if (isMaxSpecified) {
        if (deviceInfoNumber > matcher.max) {
            return false;
        }
    }
    return true;
}
function checkIsVersionMatcher(matcherProperty) {
    return (typeof matcherProperty === "undefined" ? "undefined" : _type_of(matcherProperty)) === 'object' && matcherProperty.type === MatcherType.Version;
}
function testVersionMatcher(matcher, deviceInfoString) {
    var isValidVersion = validate(deviceInfoString);
    if (!isValidVersion) {
        var errorMessage = 'A device matcher of type "Version" was used when the device info value did not parse to a version number.';
        var error = createInvalidMatcherWarning(errorMessage);
        throw error;
    }
    return satisfies(deviceInfoString, matcher.test);
}
export function checkForMatch(deviceInfo, matchers) {
    var isDeviceMatch = matchers.some(function(matcher) {
        return Object.keys(matcher).every(function(deviceInfoKey) {
            var typedKey = deviceInfoKey;
            var deviceInfoPropertyMatcher = matcher[typedKey];
            var deviceInfoProperty = deviceInfo[typedKey];
            if (deviceInfoProperty === undefined) {
                return false;
            }
            try {
                if (checkIsStringMatcher(deviceInfoPropertyMatcher)) {
                    return testStringMatcher(deviceInfoPropertyMatcher, deviceInfoProperty);
                }
                if (checkIsVersionMatcher(deviceInfoPropertyMatcher)) {
                    return testVersionMatcher(deviceInfoPropertyMatcher, deviceInfoProperty);
                }
                if (checkIsNumberMatcher(deviceInfoPropertyMatcher)) {
                    return testNumberMatcher(deviceInfoPropertyMatcher, deviceInfoProperty);
                }
            } catch (e) {
                if (_instanceof(e, CvsdkError)) {
                    var messageWithContext = 'Invalid Matcher For Key "'.concat(typedKey, '": ').concat(e.message);
                    sdkLogger.withContext('Core Video Config').warn(messageWithContext);
                    return false;
                }
                sdkLogger.error(e);
                return false;
            }
            return false;
        });
    });
    return isDeviceMatch;
}

//# sourceMappingURL=core-video-config-device-matcher-tester.js.map